let validate = function(field) {
  if (field.required && field.value === '') {
    field['error'] = true;
    field['errorText'] = 'Нужно заполнить это поле';
  } else {
    field['error'] = false;
  }

  return field
}

export default validate
